<template>
  <div>
    <div>
      <draggable v-model='editItems'>
        <v-card
          v-for="postItem in editItems.filter((item) => item.destroy === false)"
          :key="postItem.post.id"
          class="mb-2"
          outlined
          tile
        >
          <div v-if="!postItem._destroy">
            <v-card-text class="d-flex justify-space-between">
              <v-avatar class="profile" size="80" tile>
                <v-img :src="eyecatchableSrc(postItem.post)" />
              </v-avatar>
              <p class="caption">
                {{ postItem.post.title }}
              </p>
              <v-btn icon @click="deletepostItem(postItem)">
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </v-card-text>
          </div>
        </v-card>
      </draggable>
    </div>
    <div class="text-center">
      <v-btn tile color="warning" dark depressed @click="postGallary">
        <v-icon left small> mdi-plus </v-icon>
        <span class="font-weight-bold">追加</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  components: {
    draggable
  },
  mixins: [imageUtilsMixin],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    editItems: {
      get () {
        return this.items
      },
      set (value) {
        this.$emit('update-items', value)
      }
    }
  },
  methods: {
    eyecatchableSrc (post) {
      if (post.eyecatchable) {
        return post.eyecatchable.file.middle.url
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
      }
    },
    deletepostItem (postItem) {
      this.items.find((item) => item.postId === postItem.postId).destroy = true
    },
    postGallary () {
      this.$emit('post-gallary')
    }
  }
}
</script>
<style scoped></style>
